export default __webpack_public_path__ + "static/media/wallet-green.1f2fc799.svg";